<template>
  <div>
    <el-input
      placeholder="请输入"
      v-model="filterText"
      size="small"
      clearable
      @input="inputBlur"
      @focus="newAdd"
      @clear="clearInitialize">
    </el-input>
    <div @mouseout="outChange" @mouseover="overChange" style="width: 640px;height: 180px;margin-top: 4px;position: fixed;z-index: 99;" v-if="allShow || searchShow">
      <div style="display: flex;position: fixed;z-index: 99;background: white;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);" v-if="allShow">
        <div class="allTypeStyle" v-loading="treeLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
          <div v-for="(item,index) in treeData" style="line-height: 24px;">
            <div @click="getPageBybmcid(item,index)" :class="productChangeNum === index ? 'productChangeStyle2' : 'productChangeStyle'" style="">
              <div style="float: left;">
                {{item.productClassifyName}}
              </div>
              <div style="float: right;">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          <div v-if="treeData.length == 0" class="noDataStyle">
            暂无数据
          </div>
        </div>
        <div class="childTypeStyle" v-loading="divLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
          <div v-for="(i,num) in childDivData" style="line-height: 24px;">
            <div @click="onCascaderChange(i,1,num)" :class="childDivNum === num ? 'productChangeStyle3' : 'productChangeStyle'">
              <i class="el-icon-check" style="color: #409eff;margin-left: 11px;" v-if="childDivNum === num"></i>
              {{i.allProductName}}
            </div>
          </div>
          <div>
            <el-button style="margin-left: 22px;" type="text" @click="addMore(1)" v-if="addMoreShow">更多</el-button>
          </div>
          <div v-if="childDivData.length == 0" class="noDataStyle">
            暂无数据
          </div>
        </div>
      </div>
      <div style="position: fixed;z-index: 99;background: white;;margin-top: 4px;" v-if="searchShow">
        <div class="serchTypeStyle" v-loading="divLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
          <div v-for="(i,num) in searchData" style="line-height: 24px;">
            <div @click="onCascaderChange(i,2,num)" class="productChangeStyle">
              {{i.id.split(',')[1]}}
            </div>
            <div>
              <el-button style="margin-left: 22px;" type="text" @click="addMore(2)" v-if="addMoreShow">更多</el-button>
            </div>
          </div>
          <div v-if="searchData.length == 0" class="noDataStyle">
            暂无数据
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapGetters(["newgetShopProducts"])
  },
  props: {
    echoproduct_id: {
      type: String
    },
    value: {
      type: Array
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      product_id: [],
      // 重构树形组件
      divLoading: false,
			treeLoading: false,
			page: 50000,
			pageSize: 500,
      filterText: '',
      treeData: [],
      childDivData: [],
      searchData: [],
      allShow: false,
      searchShow: false,
      mouseType: 1,
      productChangeNum: '',
      childDivNum: '',
      theEcho: false,
      addMoreShow: false,
      itemId: '',
    };
  },
  async created() {
    this.getProductinfo();
  },
  methods: {
    allClear() {
      this.allShow = false
      this.searchShow = false
      this.treeLoading = false
      this.addMoreShow = false
      this.filterText = ''
    },
    // 更多
    addMore(e) {
      let pageSize = this.pageSize
      let page = this.page
      this.pageSize = Number(pageSize + 500)
      this.page = Number(page + 500)
      if (e == 1) {
        this.getPageBybmcid()
      } else {
        this.inputBlur()
      }
    },
    outChange() {
      this.mouseType = 2
    },
    overChange() {
      this.mouseType = 1
    },
    allQx() {
      if (this.mouseType == 2) {
        this.mouseType = 1
        this.allShow = false
        this.searchShow = false
        this.treeLoading = false
      }
    },
    newAdd() {
      if (!this.theEcho) {
        if (!this.productChangeNum) {
          this.productChangeNum = ''
        }
        if (!this.childDivNum) {
          this.childDivNum = ''
        }
        this.allShow = true
        this.searchShow = false
        this.treeLoading = true
      }
      let params = {
        pageNum: 1,
        pageSize: 10000,
      }
      fetch({
        url: "hcm/ProductClassify/seletProductClassify",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.treeLoading = false
          this.open(res.data.data.list)
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    // 打开
    open(data) {
			for (let zz in data) {
				data[zz].pageSize = 500
			}
			this.pageSize = 500
			this.visible = true
			this.treeData = data
      // 回显
      if (this.theEcho) {
        for (let a in this.treeData) {
          if (this.treeData[a].id == this.product_id[0]) {
            this.productChangeNum = Number(a)
          }
        }
        if (this.product_id && this.product_id[0]) {
          let item = {
            id: this.product_id[0]
          }
          this.getPageBybmcid(item)
        }
      }
		},
    // 清空数据
    clearInitialize() {
      this.filterText = ''
      this.treeData = []
      this.childDivData = []
      this.searchShow = false
      this.allShow = false
      this.product_id = []
      this.$emit("change",  this.product_id);
    },
    // 数据搜索
		inputBlur() {
			if (this.filterText == '') {
				// this.clearInitialize()
			} else {
				let params = {
					page: this.page,
					productname: this.filterText,
					type: 'add'
				}
				fetch({
					url: "hcm/hcmProduct/getListBybmcid",
					method: "get",
					params: params,
					noFormat: true,
					responseType: "text"
				}).then(result => {
					let res = JSON.parse(result);
					let {data}=res
					if(res.status == '10000'){
            console.log(123123)
						this.searchData = []
						for (let a in data) {
							for (let b in data[a].children) {
                this.searchData.push(data[a].children[b])
							}
						}
            this.allShow = false
            this.searchShow = true
					} else {
						this.$message({
							message: res.message,
							type: "error"
						});
					}
				})
			}
		},
		// 获取详细数据
		getPageBybmcid(item,index) {
      if (item) {
        this.itemId = item.id
      }
      if (!this.theEcho) {
        this.divLoading = true
      }
      this.productChangeNum = index
      let params = {
        pageNo: 1,
        pageSize: this.pageSize,
        classifyid: this.itemId,
        type: 'tree'
      }
      fetch({
        url: "hcm/hcmProduct/getPageByTree",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.divLoading = false
          this.childDivData = data.list
          if (data.total >= this.pageSize) {
            this.addMoreShow = true
          } else {
            this.addMoreShow = false
          }
          if (this.theEcho) {
            this.theEcho = false
            for (let a in this.childDivData) {
              if (this.childDivData[a].id  == this.product_id[1]) {
                this.childDivNum = Number(a)
              }
            }
          }
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
		},
    onCascaderChange(val,num,n) {
      this.childDivNum = n
      let dataArr = []
      let smallArr = []
      let productId = []
      if (num == 1) {
        this.allShow = false
        this.filterText = val.productClassifyNameAndProductName
        smallArr = [val.id, val.productClassifyNameAndProductName]
        dataArr = [val.product_classify_id, smallArr]
        productId = [val.product_classify_id, val.id]
        this.productData = dataArr;
        this.product_id = productId;
      } else {
        this.searchShow = false
        this.filterText = val.id.split(',')[1]
        smallArr = [val.id.split(',')[0], val.id.split(',')[1]]
        dataArr = [val.productClassifyId, smallArr]
        productId = [val.productClassifyId, val.idbak]
        this.productData = dataArr
        this.product_id = productId;
      }
      this.$emit("change", dataArr);
      this.$emit("setproduct", this.productData);
    },
    //回显产品信息
    getProductinfo(val) {
      console.log(val)
      if (val) {
        if (val.type == 1) {
          this.theEcho = false
        } else {
          this.theEcho = true
        }
        if (val.productinfo) {
          this.filterText = val.productinfo
        }
        if (val.productClassifyId && val.productinfoid) {
          this.product_id = []
          this.product_id = [val.productClassifyId, val.productinfoid]
          this.newAdd()
        }
      }
      this.$emit("change",  this.product_id);
    }
  }
};
</script>
<style lang='scss' scoped>
  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .productChangeStyle {
    padding-left: 6px;
    cursor: pointer;
    height: 34px;
    line-height: 34px;
    overflow: hidden;
    padding: 0 30px 0 30px;
    color: #606266;
  }
  .productChangeStyle:hover {
    background: #f5f7fa;
  }
  .productChangeStyle2 {
    padding-left: 6px;
    cursor: pointer;
    height: 34px;
    line-height: 34px;
    overflow: hidden;
    padding: 0 30px 0 30px;
    color: #409eff;
    font-weight: 700;
  }
  .productChangeStyle3 {
    padding-left: 6px;
    cursor: pointer;
    height: 34px;
    line-height: 34px;
    overflow: hidden;
    padding: 0 30px 0 0;
    color: #409eff;
    font-weight: 700;
  }
  .allTypeStyle {
    width: 180px;
    height: 180px;
    padding: 8px 0;
    border-radius: 5px 0 0 5px;
    border: 1px solid #e4e7ed;
    overflow-y: auto;
    border-right: none;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }
  .childTypeStyle {
    min-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    height: 180px;
    padding: 8px 0;
    border-radius: 0 5px 5px 0;
    border: 1px solid #e4e7ed;
    overflow-y: auto;
  }
  .serchTypeStyle {
    // width: 640px;
    min-width: 360px;
    white-space: nowrap;
    overflow: hidden;
    height: 180px;
    padding: 8px 0;
    border-radius: 5px;
    border: 1px solid #e4e7ed;
    overflow-y: auto;
  }
  .noDataStyle {
    color: rgb(204, 204, 204);
    height: 180px;
    text-align: center;
    line-height: 180px;
  }
</style>
